import { AxiosResponse } from 'axios';
import API from 'services/API';
import { EmailsSearchResponse } from './EmailSearchField.types';

const useImpersonation = () => {
  const searchHandler = async (query: string) => {
    const response: AxiosResponse<EmailsSearchResponse> = await API.get(
      `/api/identity/internal/super-admin/impersonation/search?emailPrefix=${encodeURIComponent(
        query,
      )}`,
    );

    return response.data.userEmails || [];
  };

  const impersonateUser = async (email: string) => {
    const response: AxiosResponse<{
      accessToken: string;
    }> = await API.post(
      `/api/identity/internal/super-admin/impersonation/impersonate`,
      {
        userEmail: email,
      },
    );

    return response.data.accessToken;
  };

  return {
    searchHandler,
    impersonateUser,
  };
};

export default useImpersonation;
